import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { ErrorBoundary } from '../components/error-boundary/error-boundary';
import { NotFound } from '../pages/notfound/notfound';
import { Root } from '../pages/root';

const SignUp = lazy(() => import('../pages/sign-up/sign-up'));
const PublicResultsPage = lazy(() => import('../pages/public-results/public-results'));

export const router = createBrowserRouter([
  {
    path: '/',
    ErrorBoundary,
    children: [
      { index: true, element: <Root /> },
      {
        path: 'reg',
        element: <SignUp />,
      },
      {
        path: 'table/:publicId',
        element: <PublicResultsPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);
